import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide/colors';
import { FlexRow } from 'styleguide/Row';
import { H5 } from 'styleguide/Texts';

type ViewRoutineSetIndicator = 'dropset' | 'warmup' | 'failure' | number;

const Container = styled(FlexRow)`
  justify-content: center;
  height: 30px;
  width: 30px;
`;

interface StaticSetIndicatorProps {
  indicator: ViewRoutineSetIndicator;
  style?: CSSProperties;
}

export const StaticSetIndicator = ({ indicator, style }: StaticSetIndicatorProps) => {
  const { value, textColor } = getIndicatorProperties(indicator);

  return (
    <Container style={style}>
      <H5 style={{ color: textColor, userSelect: 'none' }}>{value}</H5>
    </Container>
  );
};

const getIndicatorProperties = (
  indicator: ViewRoutineSetIndicator,
): { value: string; textColor?: string } => {
  switch (indicator) {
    case 'warmup':
      return {
        value: 'W',
        textColor: colors.orange,
      };
    case 'failure':
      return {
        value: 'F',
        textColor: colors.red,
      };
    case 'dropset':
      return {
        value: 'D',
        textColor: ' #35BAFF',
      };
    default:
      return {
        value: `${indicator}`,
      };
  }
};
